import { isDefined } from "../util/core";
import { Proto } from "./Proto";
import ISODateString = Proto.ISODateString;
import ServiceStatus = Proto.ServiceStatus;

export interface S25WsNode {
    status?: ServiceStatus;
    crc?: string;
    [key: string]: any; //allow any other properties
}

export namespace S25WsNode {
    export function isStatusChanged(node: S25WsNode) {
        return isDefined(node?.status) && node?.status !== "est";
    }
}

export type PaginateParams = {
    page: number;
    page_size: number;
    paginate: string | Proto.CharBoolean;
    order?: "asc" | "desc";
    sort?: string;
};

export interface S25WsWrapperMicroServices {
    requestId?: number;
    update?: ISODateString;
    info?: string;
    error?: string;
    messages?: string;
    [key: string]: any; //allow any other properties
}
